import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput,
    Badge, Card
} from 'reactstrap';
import parse from "html-react-parser";
import FormsType from '../../../../../../data/FormsType';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { gAPI_FormsList, putAPI_Copy_Template_Forms } from '../../../../../../constants/APIs';

const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;

const FormTemplate = ({ locale, visible, toggle, propertyId, LoadData }) => {
    const [formsDataList, setFormsDataList] = useState([]);
    const [id, setId] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsList}?groupId=${fromGroupId}&propertyId=${fromPropertyId}&lang=${locale}`,
        }).then((res) => {
            console.log(29, res.data);
            var formlist = [];
            res.data.filter(x => x.status === "Active").map(k => {
                formlist.push({ ...k, checked: false })
            })
            setFormsDataList(formlist);
            setLoading(false);
        }).catch((err) => console.log('err', err));
    }, [locale]);
    function generateRandomColor() {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    const checkedFlow = (e) => {
        const values = formsDataList.map((elem) => {
            if (elem.id === e.target.value) {
                elem.checked = !elem.checked;
            }
            return {
                ...elem,
            };
        });
        setFormsDataList(values);
    }

    const ImportTemplate = () => {
        var ids = [];
        var data = formsDataList.filter(l => l.checked === true);
        if (data.length > 0) {
            console.log(51, data);
            data.map(l => { ids.push(l.id) });
        }
        if (ids.length > 0) {
            var body = {
                id: ids,
                toGroupId: getGroupID(),
                toPropertyId: propertyId,
                fromGroupId: fromGroupId,
                fromPropertyId: fromPropertyId
            }
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Copy_Template_Forms}`,
                data: body
            }).then((res) => { LoadData(locale); toggle(); });
        }
    }
    return (<Fragment>
        <Modal isOpen={visible} toggle={() => toggle()} size="lg">
            <ModalHeader toggle={() => toggle()}>
                <h4><b> Form Templates</b> </h4>
                <p>  You'll find templates of commonly used forms below, ready for your business to use.</p>
            </ModalHeader>

            <ModalBody>
                <Row>
                    <Colxx md="12">
                        {loading ? <div className="loading" /> :
                            formsDataList && formsDataList.length > 0 &&
                            formsDataList.map((item, i) => (
                                <Card className="d-flex flex-row mb-3">
                                    <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                        <Badge
                                            key={0}
                                            className={`position-absolute badge-top-left ${item.isGlobal ? 'badge-button-color' : 'badge-button-sec'}`}
                                            color={generateRandomColor()}
                                            pill
                                        >
                                            {item.isGlobal ? 'Global' : 'Property'}
                                        </Badge>
                                        <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                            <p className="mb-1 ml-5  text-small w-40 w-sm-100">
                                                <b>{item.name}</b> <br />({item.id})
                                            </p>
                                            <p className="mb-1 text-muted text-small w-20 w-sm-100">
                                                {FormsType.filter((i) => i.value.includes(item.formType)).map(
                                                    (p) => p.label
                                                )}
                                            </p>
                                            <div className="mb-1 w-15 w-sm-100">
                                                <CustomInput
                                                    key={item.id}
                                                    type="checkbox"
                                                    id={i}
                                                    value={item.id}
                                                    checked={item.checked}
                                                    onChange={(e) => checkedFlow(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            ))
                        }
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => ImportTemplate()}>
                    Import
                </Button>
                <Button color="secondary" onClick={() => toggle()}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    </Fragment>)
}
export default FormTemplate;